<template>
    <div class="main">
        <div class="sectionContacts sectionOurStory">
            <div class="containerWrapper">
                <div class="container">
                    <div class="content">
                        <template v-for="(contact, index) in all">
                            <component :is="getComponent(contact)"
                                       :key="contact.name"
                                       :contact="contact"
                                       :delay="500*(index + 1)"
                            ></component>
                        </template>
                        <div class="womenOwnedLogoWrapper">
                            <img class="womenOwnedLogo"
                                 src="/images/women_owned_logo.png"
                                 alt="Women Owned Rooster Post Production">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'

    export default {
        computed: {
            ...mapGetters('contacts', {
                contacts: 'all',
            }),
            all() {
                return this.contacts.filter((contact) => {
                    return ['ABOUT US', 'STUDIO'].indexOf(contact.name) !== -1
                })
            },
        },
        mounted() {
            this.setSeo({
                title: 'OUR STORY | ROOSTER',
                description: 'Rooster Post Production is an award-winning commercial editorial company in Toronto.',
                keywords: '',
            })
        },
        methods: {
            ...mapActions('ui', {
                'setSeo': 'setSeo',
            }),
            getComponent(contact) {
                if (contact.type === 'text' && contact.content && contact.content.length) {
                    return 'ContactText'
                } else if (contact.type === 'portfolio' && contact.content && contact.content.length) {
                    return 'ContactImageList'
                }
            },
        }
    }
</script>
